import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/auth/use-auth";
import { Card, CardContent } from "@/components/ui/card";
import { Header } from "@/components/universal/header";
import EmailCard from "./-email-card";
import EntitiesCard from "./-entities-card";
import MfaCard from "./-mfa-card";
import NameCard from "./-name-card";

export const Route = createFileRoute("/_private/profile/")({
  component: ProfilePage,
});

function ProfilePage() {
  const { authUser } = useAuth();

  if (!authUser) return null;

  return (
    <div>
      <title>Profile - Legrande Health Portal</title>
      <Header crumbs={[{ name: "Profile", link: { to: "/profile" } }]} />
      <div className="space-y-6">
        <Card>
          <CardContent className="flex flex-wrap items-center justify-between gap-4">
            <div>
              <h1 className="text-2xl font-bold text-foreground">
                {authUser.name}
              </h1>
              <p className="text-muted-foreground">{authUser.email}</p>
            </div>
          </CardContent>
        </Card>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <NameCard authUser={authUser} />
          <EmailCard authUser={authUser} />
        </div>
        <MfaCard />
        <EntitiesCard authUser={authUser} />
      </div>
    </div>
  );
}
